export default {
	apiDomain:process.env.VUE_APP_API_DOMAIN,
	action:{
		getJobFunctionList:"/getJobFunctionList.do",
		getOccupationDetail:"/getOccupationDetail.do",
		getOccupationList:"/getOccupationList.do",
		getJobPostingList:"/getJobPostingList.do",
		getJobPostingDetail:"/getJobPostingDetail.do",
		getCourseList:"/getCourseList.do",
		getCourseDetail:"/getCourseDetail.do",
		getEducationList:"/getEducationList.do",
		getHomePage:"/getHomePage.do",
		getHomePageDraft:"/getHomePageDraft11221222112.do",
		getGrantingBody:"/getGrantingBody.do",
		getAreaOfStudy:"/getAreaOfStudy.do",
		getLearningMode:"/getLearningMode.do",
		getArticleList:"/getArticleList.do",
		getMagazineList:"/getMagazineList.do",
		getCategoryList:"/getCategoryList.do",
		getIssueContent:"/getIssueContent.do",
		getArticleDetail:"/getArticleDetail.do",
		getOccupationJobList:"/getOccupationJobList.do",
		getListByOccupation:"/getListByOccupation.do",
		getListAllByOccupation:"/getListAllByOccupation.do",
		getDetailLinkCourse:"/getDetailLinkCourse.do",
		getAllDetailLinkCourse:"/getAllDetailLinkCourse.do",
		getAssessmentList:"/getAssessmentList.do",
		getInterestQuestionList:"/getInterestQuestionList.do",
		getInterestOccupationList:"/getInterestOccupationList.do",
		getSkillQuestionList:"/getSkillQuestionList.do",
		getSkillOccupationList:"/getSkillOccupationList.do",
		getHomeOccupationList:"/getHomeOccupationList.do",
		getSimilarJobList:"/getSimilarJobList.do",
		getBgdAssessmentList:"/getBgdAssessmentList.do",
		findBgdAssTitleByTitle:"/findBgdAssTitleByTitle.do",
		getBgdAssEducationList:"/getBgdAssEducationList.do",
		getBgdAssFieldOfStudy:"/getBgdAssFieldOfStudy.do",
		getResourceGroupList:"/getResourceGroupList.do",
		getResourceLinkList:"/getResourceLinkList.do",
		getJobLevelList:"/getJobLevelList.do",
		getJobTypeList:"/getJobTypeList.do",
		getCourseLevelList:"/getCourseLevelList.do",
		getArticleDetailPreview:"/getArticleDetail11221222113.do",
		sendEmail:"/sendEmail.do",
		getInformationCentreList:"/getInformationCentreList.do",
		getHomeJobList:"/getHomeJobList.do",
		getCourseListInHomepage:"/getCourseListInHomepage.do",
		getShortTermList:"/getShortTermList.do",
		getJobCourseList:"/getJobCourseList.do",
		getAllJobCourseList:"/getAllJobCourseList.do",
		geCourseQuickQuery:"/geCourseQuickQuery.do",

	}
}